import React, { useEffect, useState } from "react";
import { Wrapper, Title, Sorriso } from "./style";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import Loading from "src/components/Loading";
import { getSection } from "src/hooks/useContentful/getSection";
import Steps from "./Steps";

export default function ComeceAgora() {
  const { data, isLoading } = useFetchContent();
  const [width, setWidth] = useState(window.innerWidth);
  const mediaPhone = 767;

  useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, [setWidth]);

  if (isLoading || !data) return <Loading />;

  const { title, backgroundColor } = getSection({
    sectionName: "landingStepperSection",
    data,
  });

  return (
    <Wrapper style={{ backgroundColor: backgroundColor }}>
      <Title tamanho="Médio">{title}</Title>
      {width <= mediaPhone && <Sorriso filter={false} />}
      <Steps />
    </Wrapper>
  );
}
